
  import { defineComponent, PropType } from 'vue';

  import * as helpers from '../helpers';
  import type { ProjectPopupRegion, ProjectPopupState } from './types';

  export default defineComponent({
    name: 'ProjectPopupBody',
    props: {
      state: {
        type: Object as PropType<ProjectPopupState>,
        required: true,
      },
    },
    emits: ['regionClick'],
    methods: {
      getRegionName(item: ProjectPopupRegion): string {
        return helpers.getRegionName(item);
      },
      onProjectClick(projectId: number): void {
        this.$router.push({ name: 'ProjectCard', params: { id: projectId } });
      },
    },
  });
